import type { ListResponse, ObjectResponse } from '../../../common/types';
import { annotationToolApiV1, getAnnotationToolBasePath } from '../../../lib';
import { ANNOTATOR_PROJECTS_TAG } from '../constants';
import type { AnnotatorProjectResonse, AnnotatorProjectSummary } from '../types/response';

export const annotatorProjectsApiSlice = annotationToolApiV1
  .enhanceEndpoints({
    addTagTypes: [ANNOTATOR_PROJECTS_TAG],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      getAnnotatorProjects: builder.query<ListResponse<AnnotatorProjectResonse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;

          return `${tempPath}/projects/annotator-projects/details`;
        },
        providesTags: [ANNOTATOR_PROJECTS_TAG],
      }),

      getAnnotatorProjectsSummary: builder.query<ObjectResponse<AnnotatorProjectSummary>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;
          return `${tempPath}/projects/annotator-projects/summary`;
        },
        providesTags: [ANNOTATOR_PROJECTS_TAG],
      }),
    }),
  });

export const { useGetAnnotatorProjectsQuery, useGetAnnotatorProjectsSummaryQuery } =
  annotatorProjectsApiSlice;
